/**
 * API key scopes — shared between server and client code.
 * Kept separate from api-key.ts to avoid pulling in Node's crypto module on the client.
 */
export const API_KEY_SCOPES = {
  ORDERS_READ: 'orders:read',
  ORDERS_WRITE: 'orders:write',
} as const;

export type ApiKeyScope = (typeof API_KEY_SCOPES)[keyof typeof API_KEY_SCOPES];
